import * as React from "react";
const SvgFiRrTaxiBus = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-taxi-bus_svg__a)">
      <path
        fill="#062147"
        d="m23.923 15.615-1.475-3.538a4.98 4.98 0 0 0-3.644-2.982l-.24-.958A1.5 1.5 0 0 0 17.109 7H14.89c-.689 0-1.288.468-1.455 1.137l-.24.958a4.98 4.98 0 0 0-3.644 2.982l-1.475 3.538a1 1 0 0 0-.077.385v3c0 1.304.836 2.415 2 2.828V22c0 1.103.897 2 2 2s2-.897 2-2h4c0 1.103.897 2 2 2s2-.897 2-2v-.172a3 3 0 0 0 2-2.828v-3a1 1 0 0 0-.076-.385M14.167 11h3.666c1.215 0 2.302.725 2.77 1.847L21.084 14H10.917l.481-1.153A2.99 2.99 0 0 1 14.168 11zM22 19a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1v-2.8l.083-.2H12v1a1 1 0 1 0 2 0v-1h4v1a1 1 0 1 0 2 0v-1h1.917l.083.2zM6.5 11H4V6.265q0-.133.009-.265H9v1a1 1 0 1 0 2 0V6h5.84a1 1 0 0 0 .969-1.249c-.534-2.074-2.121-3.703-4.141-4.249a13.7 13.7 0 0 0-7.336 0C3.781 1.193 2 3.563 2 6.265V9a2 2 0 1 0 0 4v3c0 1.304.836 2.416 2 2.83V20a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1 1 1 0 0 1-1-1v-3h2.5a1 1 0 1 0 0-2m.355-8.568a11.74 11.74 0 0 1 6.289 0A3.83 3.83 0 0 1 15.311 4H4.687a3.82 3.82 0 0 1 2.168-1.568"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-taxi-bus_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTaxiBus;
